// eslint-disable-next-line no-undef
module.exports = globalThis.WebChat.Components;
